import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Invoicing = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default Invoicing;
